import React from 'react'
import homeImg from "../Images/Code Arindam.png"
import "../CSS/Template/Home.css"
import motive from "../Images/motiv.jpg"
import { Typewriter } from "react-simple-typewriter"
import { Helmet } from 'react-helmet'
import FooTer from "./footer"


export default function Home(props) {
  let text = Typewriter({
    words: ["Arindam", "Website-Devoloper", "Coder"],
    loop: 0,
    typeSpeed: 70,
    deleteSpeed: 50,
    delaySpeed: 1000,
    cursor: true,
    cursorStyle: "|"
  })

  return (
    <>
      <Helmet>
        <title>Code Arindam | Home</title>
      </Helmet>
      <div id='home'>
        <div class="sharethis-sticky-share-buttons" ></div>
        {/* <ShareBtns/> */}
        {props.setProgress(0)}
        <h1>Hello Guys, I'm <span style={{ color: "red" }}>
          {text}
        </span></h1>
        <div className="imgMain">
          <img id="homeImg" src={homeImg} alt="loading" />
        </div>
      </div>
      <hr style={{ border: "1px dotted black", backgroundColor: "black" }} />
      {/* <AdSense
        client="ca-pub-4835378757253642"
        slot="9578487179"
        style={{ display: 'block' }}
        format='auto'
        responsive='true'
      /> */}
      <div id="sndBody">
        <div className="snsplit">
          <img id='scnImg' src={motive} alt="on the load..." />
        </div>
        <div className="snsmsplit">
          {props.setProgress(50)}
          <p className='scmp'>Some Coding Motivation Quotes</p>
          <ul style={{ listStyleType: "disc" }}>
            <li>“Humans Could be lie but code never lies.” - Code Arindam</li>
            <li>“Any fool can write code that a computer can understand. Good programmers write code that humans can understand.” – Martin Fowler</li>
            <li>“Experience is the name everyone gives to their mistakes.” – Oscar Wilde</li>
            <li>“Java is to JavaScript what car is to Carpet.” – Chris Heilmann</li>
            <li>“Knowledge is power.” – Francis Bacon</li>
            <li>“ Code is like humor. When you have to explain it, it’s bad.” – Cory House</li>
            <li>“Optimism is an occupational hazard of programming: feedback is the treatment. “ Kent Beck</li>
            <li>“Simplicity is the soul of efficiency.” – Austin Freeman</li>
            <li>Make it work, make it right, make it fast.” – Kent Beck</li>
            <li>“Any fool can write code that a computer can understand. Good programmers write code that humans can understand.” – Martin Fowler</li>
            <li>
              “Programming is like sex. One mistake and you have to support it for the rest of your life.” - Code Arindam
            </li>
          </ul>
        </div>
      </div>
      {props.setProgress(100)}
      <FooTer />
    </>
  )
}
